import { useState, useEffect, useCallback } from "react";
import { useSnackbar } from "notistack";
import styled from "styled-components";

import Modal from "../../../ui-kits/Modal";
import closeSvg from "../../../assets/media/icons/close.svg";
import Form from "../../../ui-kits/form/Form";
import { statusesOfForm } from "../../../utilities/consts/models";
import { sendConsultingRequest } from "../../../services/consultingRequestServices";
import { consultingRequestFormFields } from "../../../utilities/consts/formFields";
import { getConsultingRequestModalTitle } from "../../../services/pagesRequestServices";
import HtmlContent from "../misc/HtmlContent";

const consultingRequestForModal = consultingRequestFormFields.filter(
  (item) => item.key !== "title" && item.key !== "description"
);

const ConsultingRequestModal = ({ isOpen, toggleOpen, productInfo }) => {
  const [statusForm, changeStatusForm] = useState(statusesOfForm.filling);
  const { enqueueSnackbar } = useSnackbar();
  const [pageTitle, changePageTitle] = useState(null);

  const onSubmit = (data) => {
    changeStatusForm(statusesOfForm.sending);

    const fullData = {
      ...data,
      title: `درخواست دمو و مشاوره ${productInfo.title}`,
      description: `درخواست دمو و مشاوره ${productInfo.title}`,
    };

    sendConsultingRequest(fullData)
      .then(() => {
        enqueueSnackbar("درخواست شما با موفقیت ارسال شد.", {
          variant: "success",
        });
        changeStatusForm(statusesOfForm.success);
        toggleOpen(false);
      })
      .catch(() =>
        enqueueSnackbar("ارسال درخواست با خطا مواجه شد.", { variant: "error" })
      )
      .finally(() => {
        changeStatusForm(statusesOfForm.filling);
      });
  };

  const getPageTitle = useCallback(() => {
    return getConsultingRequestModalTitle().then((res) => changePageTitle(res));
  }, []);

  useEffect(() => {
    getPageTitle();
  }, [getPageTitle]);

  return isOpen ? (
    <Modal>
      <StyledDialog>
        <div className="screen" onClick={() => toggleOpen(false)} />
        <div className="dialog_container border-blue rounded bg-background text-white p-3">
          <div className="text-left">
            <button className="btn p-0" onClick={() => toggleOpen(false)}>
              <img src={closeSvg} width={32} alt="" />
            </button>
          </div>
          <div className="px-2">
            <div className="row mx-0">
              <div className="col-12 pb-3 px-0">
                <p className="text-green text-14 my-2">
                  <HtmlContent
                    rawHtml={pageTitle?.title.replace(
                      "{productTitle}",
                      `<span class="text-white">${productInfo.title}</span>`
                    )}
                  />
                </p>
              </div>
              <div className="col-12 pb-3 px-0">
                <Form
                  fields={consultingRequestForModal}
                  onSubmit={onSubmit}
                  isSending={statusForm === statusesOfForm.sending}
                  isSuccess={statusForm === statusesOfForm.success}
                />
              </div>
            </div>
          </div>
        </div>
      </StyledDialog>
    </Modal>
  ) : (
    <></>
  );
};
export default ConsultingRequestModal;

const StyledDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1003;

  .screen {
    width: 100vw;
    height: 100vh;
    background: rebeccapurple;
    position: fixed;
    top: 0;
    background: rgba(0, 6, 50, 0.9);
  }

  .dialog_container {
    width: 600px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid;

    .text-left {
      text-align: left;
    }

    .dialog_container__content {
      max-height: 80vh;
      overflow: auto;
    }
  }

  @media (max-width: 768px) {
    .dialog_container {
      width: 90vw;
    }
  }
`;
